import { getProductUpdates } from 'api/generated/api/product-updates';
import type { WhatsNewStateResponse } from 'api/generated/types/whatsNewStateResponse';

import type { WhatsNewMemory } from '../../productUpdates/selectWhatsNewNotice';

export type WhatsNewStateClient = {
  load: () => Promise<WhatsNewMemory>;
  dismiss: (ids: readonly string[]) => Promise<WhatsNewMemory>;
};

function toMemory(response: WhatsNewStateResponse): WhatsNewMemory {
  return {
    firstOpenedOn: response.first_opened_on,
    dismissedIds: new Set(response.dismissed_update_ids),
  };
}

async function load(): Promise<WhatsNewMemory> {
  const { productUpdatesGetWhatsNewState } = getProductUpdates();
  return toMemory(await productUpdatesGetWhatsNewState());
}

async function dismiss(ids: readonly string[]): Promise<WhatsNewMemory> {
  const { productUpdatesDismissWhatsNewUpdates } = getProductUpdates();
  return toMemory(
    await productUpdatesDismissWhatsNewUpdates({ update_ids: [...ids] })
  );
}

export const whatsNewClient: WhatsNewStateClient = { load, dismiss };
